<div class="community-post">
  <div class="message-header">
    <img
      [routerLink]="['/profile', post.author.id]"
      [src]="post.author.id == user.id ? (user.photoURL ? user.photoURL : './assets/images/default_avatar.jpg') : post.author.photo ? post.author.photo : './assets/images/default_avatar.jpg'"
      class="profile-photo"
    />
    <fui-heading [text]="post.author.name" [level]="2" fontSize="f6" extraClasses="t-18 bold"></fui-heading>
    <span class="timestamp">{{ post.created.toDate() | date: "MMM Do [at] hh:mm" : true }}</span>
    <div class="channels">
      @if (!post.channels) {
        <span class="channel" (click)="channelSelected.next('general')">General</span>
      }
      @for (channel of post.channels; track channel) {
        <span class="channel" (click)="channelSelected.next(channel)">{{ communityService.skillsMap[channel].title }}</span>
      }
    </div>
  </div>
  <div class="message-container">
    <span [innerHTML]="post.htmlMessage | safe: 'html'"></span>
  </div>
  <div class="post-actions d-flex justify-content-end">
    <fa-icon icon="reply" ngbTooltip="Reply"></fa-icon>
    @if (post.edited) {
      <span class="c-gray">Edited&nbsp;&nbsp;</span>
    }
    <fa-icon ngbTooltip="Like this post" (click)="like()" [class.disabled]="!post.likes || !post.likes.includes(this.userService.user?.id)" icon="thumbs-up"></fa-icon>
    @if (post.likes && post.likes.length) {
      <span class="like-count">{{ post.likes.length }}</span>
    }
    @if (post.author.id == user.id) {
      <fa-icon icon="pencil-alt" (click)="edit()" ngbTooltip="Edit"></fa-icon>
    }
    @if (post.author.id == user.id) {
      <fa-icon icon="trash-alt" (click)="delete()" ngbTooltip="Delete"></fa-icon>
    }
  </div>
</div>
